import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/toPromise';
import { SxHttpService } from 'app/infrastructure/services/sxHttp.service';
import { EntityChildElement } from '../entityWithChilds/model/EntityChildElement';
import { EntityChildsContext } from '../entityWithChilds/model/EntityChildsContext';

@Injectable()
export class EntitiesService {

  url : string = "api/entityChilds/GetWithChilds";

  constructor(private sxHttp: SxHttpService) { }
  
  getEntityElements(context: EntityChildsContext): Observable<EntityChildElement> {
    const request$ = this.sxHttp.post(this.url, context)

    return request$.map(result => {
      let response = result.json().data as EntityChildElement
      switch(response.entityType) { 
        case "ORGANIZACION": { 
           response.title = "SUBSCRIPCIONES";
           break; 
        } 
        case "SUBCRIPCION": { 
           response.title = "NEGOCIOS";
           break; 
        } 
        case "CHANNEL": { 
          response.title = "PRODUCTOS";
          break; 
       } 
        default: { 
           break; 
        }
      } 
      //  response.title = context.subscriptionCode!="" ? "NEGOCIOS":"SUBSCRIPCION";
      //  //context.subscriptionCode!=null && context.channelCode==null ? "NEGOCIOS": "";
      //  response.title = context.channelCode!="" && context.channelCode!=null ? "PRODUCTOS":response.title;
      // //response.title  context.subscriptionCode !=null ? 'NEGOCIOS': "SUBSCRIPCION";
      // //context.subscriptionCode!=null && context.channelCode==null ? "NEGOCIOS":

      return response;  
    });
  }

  getOrganizationsList(context: EntityChildsContext): Observable<EntityChildElement[]> {
    const request$ = this.sxHttp.get("api/entityChilds/getEntityOrganizationList")

    return request$.map(result => {
      let response = result.json().data as EntityChildElement[]
      return response;  
    });
  }

  getForList(context: EntityChildsContext): Observable<EntityChildElement[]> {
    const request$ = this.sxHttp.post(this.url + '/getForList', context)

    return request$.map(result => {
      let response = result.json().data as EntityChildElement[];
      return response;
    });
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/entity/service/entities.service.ts